import type {
  Activity,
  IDemo,
  IPresentation,
  IRecording,
} from '@carboncopyco/types';
import { List } from '@carboncopyco/ui';
import ActivityManager from './ActivityListManager';

type TeamActivityListProps = {
  activities: Activity<IDemo | IRecording | IPresentation>[];
  goToDemoPageByWorkspace: (
    demoId: number,
    workspaceId: string,
    tab?: string | undefined
  ) => void;
  goToClonePageByWorkspace: (
    id: string | number,
    workspaceId: string,
    tab?: string | undefined
  ) => void;
  goToPresentationPageFromHomepage: (
    id: string | number,
    workspaceId: string | number,
    tab?: string | undefined
  ) => void;
};

export const TeamActivityList = ({
  activities,
  ...props
}: TeamActivityListProps) => {
  if (!activities || !activities.length) {
    return null;
  }

  return (
    <List
      data={activities}
      renderItem={(itemData) => (
        <ActivityManager
          data={itemData}
          {...props}
        />
      )}
    />
  );
};
